/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.before-after-slider-outer' ).slick( {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: $( '.before-after-nav-wrapper' ),
        prevArrow: '<button type="button" class=""><svg class="text-brand-bright-blue icon icon-left-arrow mb-1 mr-1"><use xlink:href="#icon-left-arrow"></use></svg> Previous case</button>',
        nextArrow: '<button type="button" class="">Next case <svg class="text-brand-bright-blue icon ml-1 mb-1 icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg></button>',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
